<template>
  <div class="vuepal-local-tasks">
    <ul>
      <li
        v-for="task in tasks"
        :key="task.baseId"
        :data-route-name="getRouteName(task)"
      >
        <NuxtLink v-if="isNuxtRouted(task)" :to="task.url.path">{{
          task.title
        }}</NuxtLink>
        <a v-else-if="task.url.path" :href="task.url.path">{{ task.title }}</a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { useRoute, computed, useLazyAsyncData } from '#imports'
import { NuxtLink } from '#components'
import adapter from '#vuepal/adapter'
import { type LocalTask } from '#vuepal/types'

const route = useRoute()

const props = defineProps<{
  pathOverride?: string
}>()

const path = computed(() => props.pathOverride || route.path)

const { data: tasks } = await useLazyAsyncData(
  'localTasks:' + path.value,
  () => {
    if (adapter.getLocalTasks) {
      return adapter.getLocalTasks(path.value)
    }
    return Promise.resolve([])
  },
  { watch: [path] },
)

function isNuxtRouted(task: LocalTask): boolean {
  return task.url.routeName === 'entity.node.canonical'
}

function getRouteName(task: LocalTask) {
  const url = task.url
  return url && 'routeName' in url ? url.routeName : ''
}
</script>
